import { BaseEvents } from '@/shared/utils';

export const SubscriptionEventKeys = {
  subscription: {
    list: 'subscription/list',
    view: 'subscription/view',
    update: 'subscription/update',
    create: 'subscription/create',
    cancel: 'subscription/cancel',
  },
  payment: {
    openPortal: {
      init: 'payment/open-portal/init',
      do: 'payment/open-portal/do',
    },
  },
} as const;

export interface SubscriptionEvents extends BaseEvents {
  'subscription/list': void;
  'subscription/view': { email: string };
  'subscription/update': string;
  'subscription/create': {
    priceId: string;
    trialPeriodDays?: number | null;
  };
  'payment/open-portal/init': void;
  'payment/open-portal/do': void;
  'subscription/cancel': void;
}
